<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { roundingruleService } from "../../../../../services/companyservice/roundingrule.service";
import List from "../../../../../components/list";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Rounding List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      termList: {},
      fetchingStats: false,
      title: "Rounding Templates List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '?page=0') {
      this.fetchingStats = false;
      roundingruleService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.termList = response;
        });
    },

    deleted: function(id) {
      roundingruleService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-company-round-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-company-round-add'}" :title="$t('setting.company.round.text')" />
    <List v-bind:dataList="termList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `name: ${$t('setting.company.round.name')}`, 
            `method: ${$t('setting.company.round.method')}`, 
            `ratio: ${$t('setting.company.round.ratio')}`, 
            `variance_at: ${$t('setting.company.round.variance_at')}`, 
          ]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-company-round-edit'}"
          v-bind:filter="{
            search: ['rounding_rules.name'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>